import Form from '../../lib/forms'

class CFBlogMobile {
  constructor () {
    this.prefix = '.c-topfooter-blogmobile'
    this.formTools = new Form(this.prefix)
    this.formTools.init()
  }
}

export default CFBlogMobile
